import animateScrollTo from 'animated-scroll-to';
import { useEffect } from 'react';
import { useGetParams } from './useGetParams';

export const useScrollText = (
  contentRef,
  contentContainerRef,
  message,
  scrollTrigger
) => {
  const { scrollDelay, scrollSpeed, duration } = useGetParams();

  useEffect(() => {
    if (!contentRef.current || !contentContainerRef.current) return;
    if (
      contentRef.current.getBoundingClientRect().height -
        contentContainerRef.current.getBoundingClientRect().height >=
      10
    ) {
      const height = contentRef.current.getBoundingClientRect().height;
      const elementToScroll = contentContainerRef.current;

      const calculatedDuration =
        scrollSpeed *
        (Math.ceil(
          contentRef.current.getBoundingClientRect().height /
            ((window.innerHeight / 100) * 5 * 1)
        ) -
          3);
      const animationDuration =
        calculatedDuration > duration - 2500
          ? duration - 2500
          : calculatedDuration;

      setTimeout(
        () => {
          animateScrollTo([0, height], {
            elementToScroll,
            minDuration: animationDuration,
            maxDuration: animationDuration,
          });
        },
        scrollDelay >= duration ? 0 : scrollDelay
      );
    }
  }, [
    message,
    scrollSpeed,
    scrollDelay,
    duration,
    contentRef,
    contentContainerRef,
    scrollTrigger,
  ]);
};
